export default function ProjectOverview() {
  return (
    <section className="py-24 px-6 bg-gradient-to-b from-[#F5F9F6] to-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-white border border-[#C8E6C9] mb-6">
              <i className="ri-building-line text-[#2D7A3E] text-lg mr-2"></i>
              <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">廃校活用プロジェクト</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6">
              地域の課題を<br />
              新しい価値に変える
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              全国で増え続ける廃校。その多くは活用されないまま放置されています。私たちは、この地域課題を持続可能な産業拠点へと転換し、新しい雇用と経済循環を生み出します。
            </p>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-6 h-6 bg-[#2D7A3E] rounded-full flex items-center justify-center mr-3 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-[#1A2332] mb-1">施設の有効活用</h4>
                  <p className="text-gray-600 text-sm">既存の校舎や体育館を養殖施設として再生</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-6 h-6 bg-[#2D7A3E] rounded-full flex items-center justify-center mr-3 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-[#1A2332] mb-1">働く場所と住む場所の提供</h4>
                  <p className="text-gray-600 text-sm">雇用創出と移住促進を同時に実現</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-6 h-6 bg-[#2D7A3E] rounded-full flex items-center justify-center mr-3 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-[#1A2332] mb-1">地域経済の活性化</h4>
                  <p className="text-gray-600 text-sm">新しい産業による経済循環の創出</p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/4aab2a4970b9ae27188c7c4241a3239e.jpg"
                alt="廃校を活用した養殖施設"
                className="w-full h-[500px] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-xl border border-[#E8F5E9]">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-[#2D7A3E] rounded-lg flex items-center justify-center">
                  <i className="ri-line-chart-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-[#2D7A3E]">100+</p>
                  <p className="text-sm text-gray-600 whitespace-nowrap">雇用創出目標</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}